import React from 'react';
export function Footer() {
  return <footer className="bg-cosmic-black border-t border-gold-primary border-opacity-20 py-12" data-id="element-201">
      <div className="container mx-auto px-6" data-id="element-202">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0" data-id="element-203">
          <div className="text-center md:text-left" data-id="element-204">
            <h3 className="text-2xl font-serif font-bold text-gold-light mb-2" data-id="element-205">
              LOS 12
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-206">
              Doce entidades. Doce energías. Doce reinos.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-207">
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-208">
              Términos y condiciones
            </a>
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-209">
              Política de privacidad
            </a>
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-210">
              Política de reembolsos
            </a>
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-211">
              Contacto/soporte
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-gray-500 text-sm" data-id="element-212">
          © 2026 LOS 12. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}